import { create } from "zustand";

interface RightPanelTopbarStore {
  hasRightPanelTopbar: boolean;
  setHasRightPanelTopbar: (hasTopbar: boolean) => void;
}

export const useRightPanelTopbarStore = create<RightPanelTopbarStore>((set) => ({
  hasRightPanelTopbar: false,
  setHasRightPanelTopbar: (hasTopbar) =>
    set({ hasRightPanelTopbar: hasTopbar }),
}));
